import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../Wrapper/WrapperByRole'

const ClientWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='client' {...props} />

export default ClientWrapper